import { ReservablesList } from '@/components/rooms-list';
import VisitorLayout from '@/layouts/visitor-layout';
import { tablesShow } from '@/routes';
import { Head } from '@inertiajs/react';

export default function tables({
    response,
}: {
    response: {
        tables: App.Data.TableData[];
        customer: App.Data.CustomerData | null;
        newsletters: App.Data.NewsletterData[];
    };
}) {
    return (
        <VisitorLayout>
            <Head>
                <title>Our Tables</title>
                <meta name="description" content="View our tables and find the perfect one for your event and book it online" />
                <meta name="image" content={import.meta.env.VITE_APP_URL + '/logo.jpg'} />
                <meta name="url" content={tablesShow().url} />
                <meta name="canonical_url" content={tablesShow().url} />
                <meta name="type" content="website" />
                <meta name="author" content="Let\'s Cafe" />
                <meta name="robots" content="index, follow" />
                <meta name="published_time" content={new Date().toISOString()} />
                <meta name="modified_time" content={new Date().toISOString()} />
                <meta name="site_name" content="Let\'s Cafe" />
                <meta name="section" content="Tables" />
                <meta name="tags" content="tables, events, bookings" />
                <meta name="twitter_username" content="Let\'s Cafe" />
                <meta name="og:title" content="Our Tables" />
                <meta name="og:description" content="View our tables and find the perfect one for your event and book it online" />
                <meta name="og:image" content={import.meta.env.VITE_APP_URL + '/logo.jpg'} />
                <meta name="og:url" content={tablesShow().url} />
                <meta name="og:type" content="website" />
                <meta name="og:site_name" content="Let\'s Cafe" />
                <meta name="og:section" content="Tables" />
                <meta name="og:tags" content="tables, events, bookings" />
                <meta name="og:twitter_username" content="Let\'s Cafe" />
                <meta name="og:published_time" content={new Date().toISOString()} />
                <meta name="og:modified_time" content={new Date().toISOString()} />
                <meta name="og:locale" content="en" />
                <meta name="og:canonical_url" content={tablesShow().url} />
                <meta name="og:alternates" content={tablesShow().url} />
                <meta name="og:schema" content={tablesShow().url} />
            </Head>
            <ReservablesList
                reservables={response.tables}
                customer={response.customer}
                reservableType="table"
            />
        </VisitorLayout>
    );
}
